export default __webpack_public_path__ + "static/media/quotes.e95923f4.svg";